import { createConfirmation } from "react-confirm";
import AddInventoryDialog from "./AddInventoryDialog";

export const showAddInventoryDialog = createConfirmation(AddInventoryDialog);
